var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icon-css-je",
    width: 640,
    height: 480,
    viewBox: "0 0 30 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M-5.3-6h40v30h-40z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(.75 0 0 .75 4 2.3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-10.3-6h50v30h-50z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#df112d",
    fillRule: "evenodd",
    d: "M-10.3-6v2L11.6 9l-21.8 13v2H-7l21.8-13 21.7 13h3.2v-2L18 9 39.8-4v-2h-3.3L14.7 7-7-6h-3.2z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.7 -6) scale(.20361)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e8112d",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M132.7 22.2c3.1 12.8 1.4 28.6-12.9 37.4-14.2-8.8-16-24.6-12.8-37.4 3.4-3 18.6-4.9 25.7 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9dd16",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M119.8 19.7a26 26 0 0 1 13 3.1 28 28 0 0 1 4.9-12.1c-2.5 0-3.6 1.3-3.6 2.6-.6-1.7-3-1.6-3.8-.7 2.7 1.8.6 5-1.8 4.4-1.1-.3-1.7-1.1-2-2.3a1.3 1.3 0 1 0-.5 0 2.9 2.9 0 0 1-3.1 1.3c-1.3-.3-1.9-1.5-1.9-2.5 0-2.7 2.6-3.1 3.4-2.6 0-1.8-2.9-3.3-3.8-1.8a4.8 4.8 0 0 0-.8-5.8A4.8 4.8 0 0 0 119 9c-.9-1.5-3.7 0-3.7 1.8.7-.5 3.3-.1 3.3 2.6 0 1-.6 2.2-1.8 2.5-1 .3-2.4-.1-3.2-1.3a1.3 1.3 0 0 0 .6-.4 1.3 1.3 0 1 0-1.1.4c-.2 1.2-.9 2-2 2.3-2.4.7-4.5-2.6-1.8-4.4-.8-1-3.2-1-3.8.7 0-1.3-1.1-2.6-3.6-2.6a28 28 0 0 1 5 12.1 26 26 0 0 1 13-3.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "b",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#f9dd16",
    strokeWidth: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.7 32.2c-.4 0-.4.5-.5.5.8 0 1.2-.3 1.4-.7v.6c.6-.2.8-.7.6-1l.7.2c-.4-.3-.1-1-.8-1.4.2 0 .6.2.8.5-.1-.7-.2-1.1-.8-1.5h.5a.9.9 0 0 1-.4-.8c0-.4-.2-.4-.6-.3l-1.8.1c-1 0-2 0-2.8-.6 1.3.6 3-.6 3-1.5 0-1-1.4-2-4-1.4-2.6.6-5.8.4-5.8-.5s2.3-1 3.5-.8c1.2.2 2 .3 4.2-.5-.5.2-2.3.3-3.7-.1s-4.8-.4-4.8 1.4c0 1.9 3.6 1.7 6.8 1.2 1.8-.2 2.8 0 2.8.5 0 .6-1.7.8-3 .7a10 10 0 0 0-4.1.3c-1.3.4-2.2 0-3.6.3-.7 0-2.4 0-3.2-1.4-.5.4-2 1.1-2.3 1.9-.3.6 0 1.3.4 2 .6.8-.3.7-1 .7-.8 0-2 0-2.6-.8-.6-.6-1.3-1.1-1.9-.7-.3.3 0 .6.2.5l.8.2a1 1 0 0 0-1 .1c-.3.2 0 .6.3.5.2-.1.7-.2 1 0-.3 0-.7 0-.8.2s0 .4.3.4c.6 0 .7.4 1.3.3a.9.9 0 0 0-.7.4c.6-.3 1.1.4 1.8.2-.2.1-.7.4-.7.6.4-.5 3.2.4 3.2-.7l-.1.8c.3-.2 1.4-.3 1.8-1 0 .2 0 .5-.2.6.3 0 .8-.2 1.3-.9.2-.3.2-.5.2-.7.5 0 .8-.1 1.2-.4.4-.3.8.3 1.5-.2.6-.4 1.2 0 1.6-.2.3-.2.8 0 1.2-.2s1 .1 1.6-.4c1 .4 2.3 1 5.2.5 1.6-.3 2.2.3 2.2 1 0 .6-.4.6-.6.6-1 .1-1.3-.3-1.7-.2-.2.1-.4.5 0 .7-.3.1-.3.4-.1.5s.5 0 .8-.1c-.4.1-.7.4-.5.7.1.2.4.3.7 0 .3-.4.8-.7 1.2-.7zm-18.6-8c-.8-.3-1-.3-.9.4 0 .3.3.7.5.9 0-.3.1-1 .4-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.8 24.3c.8-.4 1.1-.4.9.3 0 .3-.3.7-.5.9 0-.3 0-1-.4-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.5 23.8c1.6 0 1.8.8 1.7 1.7 0 1-.5.6-.8 2-.1.4-.5.5-1 .5-.3 0-.7 0-.9-.6-.3-1.3-.8-1-.8-2 0-.8.2-1.6 1.8-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.4 27.5c-.4-.2-.7 0-.9 0 .6.1.6.8 1.8 1-.3 0-.4.2-.7 0 .5.4 1 .9 2.2.9.7 0 .2.3-.2.1.4.5 1.3.1 1.9 1 0-.7-1-1.7-.5-2.4-1.7-.1-1.8-1-2.7-1.7-.8-.6-.9-1.2-1.2-2.3-.1-.5-.7-.8-1-.7-.3 0-.5.3-.2.5.2.2.6.2.6.7-.3-.4-.8-.5-1-.3-.1.2 0 .5.2.5.5 0 .2.6.7 1-.5-.5-.9-.6-1.2-.3-.1.2 0 .5.4.5.5 0 1 1.2 1.8 1.5zm13 4.6c-.2 0-.1.5-.5.5.8 0 1.3-.2 1.6-.5l-.2.5c.4-.3 1.5-.4 2-.3s.6-.1.8-.4c.2-.4 0-.6-.3-.8-.3-.3-.4-.7-.3-1.3-1.4-2-4-1-4-.2.9 1.1 1 1 1.8 1.1.7.2 1.2.2.7.6-.2.2-1 0-1.5.1-1.3 0-2-.9-2.3-.4-.3.4 0 .6.6.6-.4 0-1 0-.9.4.2.7.8-.1 1.1.1-.2 0-.6.1-.6.3 0 .2.5.5 1 0a1.6 1.6 0 0 1 1-.3z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.5 29.2c-.4-.2-.9-.3-1.4-.2m-5.6 0c-.4.8-.2 1.2-.1 1.6m-4-5.6c.2.2.4-.2.8.2-.1-.1-.3.3-.6 0m2-.1c-.3 0-.5-.3-.9.1.1-.1.3.3.6 0M113.7 25.2v.3c.1.7.3 1-.3 1-.5 0-.3-.3-.2-1v-.3"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0016",
    strokeWidth: 0.1,
    d: "M113.5 27.7c.4 0 .6 0 .6-.6 0-.2.3-.3.1-.7.2.4-.7.4-.7.2 0 .2-1 .2-.8-.2-.1.4.2.5.1.7 0 .6.2.6.7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.1,
    d: "M113 26.5l-1-.3m1 .3h-1m1 .1l-.9.3m1.7-.4l1-.3m-1 .3h1.2m-1.2.1l1 .3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0051ba",
    strokeWidth: 0,
    d: "M108.1 23.4c-.3-.4-1 0-1 .4.2-.3.6.1.9 0 .1 0 .3-.2.1-.4zm-.3.9c-.3-.4-1.1 0-1.1.4.2-.3.6.1.9 0 .1 0 .3-.3.2-.4zm-.2 1.2c-.4-.4-1.1 0-1 .5.2-.3.6 0 .8 0 .2-.1.3-.4.1-.5zm.3 3.7c-.4-.4-1 .1-1 .6.2-.4.7 0 1-.2 0 0 .2-.3 0-.5zm0 .7c-.5-.1-1 .6-.7 1 0-.5.6-.3.8-.5l-.1-.5zm.6.7c-.5-.2-1 .4-.7.8 0-.3.6-.2.7-.4v-.5zm11.7 1.1c-.5-.1-1 .5-.7 1 0-.5.6-.3.8-.5l-.1-.5zm.6.6c-.5-.1-.9.6-.6 1 0-.5.6-.4.7-.6.1-.1.1-.4 0-.4zm-.4-1.4c-.4-.2-1 .4-.9.8.2-.4.7-.1.9-.3V31zm8.3 1c-.4-.1-.8.6-.6 1 0-.4.6-.3.8-.5 0-.2 0-.5-.2-.5zm0-.7c-.4-.3-1 .3-.8.7.2-.3.7-.1.9-.3v-.5zm.4 1.3c-.5 0-.9.7-.6 1 0-.4.6-.3.7-.5.1-.2 0-.4-.1-.5zm-15.6-5.2c.3 0 .4.1.4.7 0 1 0 1.6-.4 1.6-.3 0-.3-.5-.3-1.3 0-.4 0-.7-.1-.6 0-.3.1-.4.4-.4z"
  })), /*#__PURE__*/React.createElement("use", {
    width: 30,
    height: 18,
    transform: "matrix(.9 0 0 .9 11.6 13.7)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 30,
    height: 18,
    transform: "matrix(.67 0 0 .75 39.2 27.5)",
    xlinkHref: "#b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJey);
export default __webpack_public_path__ + "static/media/jey.937a06a7f102cb5c70b67b7c0eb9bb51.svg";
export { ForwardRef as ReactComponent };